import { useState } from "react";

// Services
import ScrapeServices from "../../services/Scrape.services";
import TrackFeatureServices from "../../services/TrackFeature.services";

// Helper
import { getServer } from "../../utils/oneintelligence/OneIntelligenceHelper";

const useAddBrand = () => {
    const [loading, setLoading] = useState(false);

    const addBrand = async (keywordDetails, callback = () => { }) => {
        let usedUrl = "";

        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({
            featureKey: "addTopicBrand",
        });

        const callBackStart = (params, url) => {
            usedUrl = url;
            startMonitor(params, { url: usedUrl });
        };

        try {
            const { fullPath, healthcareCategory, healthcareCategoryType } =
                keywordDetails;

            const [marktepackage, country, category, subcategory, microsegment] =
                fullPath.split("\\");

            const { code: savantCode, url: savantUrl } = getServer();

            setLoading(true);
            const promise = ScrapeServices.runScrape(
                {
                    country_code: country.toLowerCase(),
                    savant_country_code: savantCode,
                    savant_url: savantUrl,
                    package: "pharma",
                    package_name: marktepackage,
                    freeform: category,
                    healthcare_research_category: healthcareCategory,
                    healthcare_research_category_type: healthcareCategoryType,
                    microsegments: [
                        {
                            category,
                            subcategory,
                            microsegment,
                            related_topic: "",
                            already_scraped: 1,
                        },
                    ],
                },
                callBackStart
            );

            promise.then((response) => {
                endMonitor(response, { url: usedUrl });
            });

            await promise;
            setLoading(false);
            callback();
        } catch (error) {
            console.error(error);
            setLoading(false);
            callback();
        }
    };

    return {
        loading,
        addBrand,
    };
};

export default useAddBrand;
